import { cn } from './cn';
import { keyLabels } from './hotkeys';

/** A keyboard key hint, e.g. <Kbd keys="mod+k" /> → ⌘ K. `inverted` on filled (primary, danger) buttons. Hidden on touch screens. */
export function Kbd({ keys, inverted, className }: { keys: string; inverted?: boolean; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-0.5 pointer-coarse:hidden!', className)} aria-hidden>
      {keyLabels(keys).map((k, i) => (
        <kbd
          key={i}
          className={cn(
            'inline-flex h-[18px] min-w-[18px] items-center justify-center rounded border px-1 font-sans text-2xs font-bold leading-none',
            inverted ? 'border-current/30 bg-current/10 text-current' : 'border-line-strong bg-subtle text-ink-muted',
          )}
        >
          {k}
        </kbd>
      ))}
    </span>
  );
}
